import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserEmailService {

  constructor(private http: HttpClient) { }

  checkUserEmail(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'usuario/email');
  }

  updateUserEmail(email: string): Observable<any> {
    return this.http.post<any>(environment.apiUrl + 'usuario/email', { email });
  }
}
